/* eslint-disable no-param-reassign */
const log = require('log').create('query') // eslint-disable-line

const Query = {

    getQuery(key, loc) {
        let query = ''
        key = key || '?'
        loc = loc || document.location.href
        if (loc.indexOf(key) > -1) {
            query = loc.substring(loc.indexOf(key) + key.length, loc.length)
        }
        return query
    },

    parse(query_string) {
        const query = query_string || this.getQuery()
        const query_object = {}
        const params = query.split('&')

        params.forEach((param) => {
            const [key, value] = (
                param.split('=')
                    .map(item => decodeURIComponent(item))
            )
            if (! key) return
            query_object[key] = value
        })

        return query_object
    },

    stringify(data) {
        // convert dict into an array of key=value strings
        const params = Object.keys(data).map((key) => {
            const value = data[key]
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        })

        // join the array of strings with &
        return params.join('&')
    },

}

module.exports = Query
